import { ChangeDetectionStrategy, Component, OnInit, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { DataState } from '@libs/utils';
import { AppointmentReason } from '@libs/store';
import { ReasonSelectorModalService } from './reason-selector-modal.service';
import { InitialReasonComponent } from './initial-reason/initial-reason.component';
import { OtherCodesComponent } from './other-codes/other-codes.component';
import { TreatmentPlanSelectorComponent } from './treatment-plan/treatment-plan-selector.component';
import { ReasonSelectorModalFooterComponent } from './reason-selector-modal-footer/reason-selector-modal-footer.component';

export interface ReasonSelectorModalResult {
  addedReasons: AppointmentReason[];
}

export enum ReasonSelectorModalTabs {
  InitialReason = 'initial-reason',
  TreatmentPlan = 'treatment-plan',
  OtherCodes = 'other-codes',
}

@Component({
  selector: 'lib-reason-selector-modal',
  templateUrl: './reason-selector-modal.component.html',
  styleUrl: './reason-selector-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ReasonSelectorModalService],
  imports: [
    CommonModule,
    TranslateModule,
    InitialReasonComponent,
    OtherCodesComponent,
    TreatmentPlanSelectorComponent,
    ReasonSelectorModalFooterComponent,
    SvgIconComponent,
  ],
})
export class ReasonSelectorModalComponent implements OnInit {
  public activeTab: ReasonSelectorModalTabs = ReasonSelectorModalTabs.InitialReason;
  public ReasonSelectorModalTabs = ReasonSelectorModalTabs;
  private readonly reasonSelectorModalService = inject(ReasonSelectorModalService);
  public viewModel = this.reasonSelectorModalService.viewModel;
  public DataState = DataState;

  public dialog = inject(Dialog);
  private readonly dialogRef = inject(DialogRef);
  public closeDialog(): void {
    this.dialogRef.close();
  }

  public selectedReasons = computed(() => this.reasonSelectorModalService.viewModel().selectedReasons);

  public ngOnInit(): void {
    this.reasonSelectorModalService.init();
  }

  public addReason(reason: AppointmentReason): void {
    this.reasonSelectorModalService.addReason(reason);
  }

  public removeReason(reason: AppointmentReason): void {
    this.reasonSelectorModalService.removeReason(reason.code);
  }

  public addReasons(): void {
    this.dialogRef.close({
      addedReasons: this.reasonSelectorModalService.selectedReasons(),
    });
  }

  public selectTab(tab: ReasonSelectorModalTabs): void {
    this.activeTab = tab;
  }
}
